module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": _vm.columns.length
    },
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _c('tr', _vm._l((_vm.columns), function(column) {
    return _c('table-header-cell', {
      key: column.id,
      attrs: {
        "data": column
      },
      on: {
        "toggleOrder": function($event) {
          return _vm.toggleOrder(column.id)
        }
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5288f8c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ansergy-datatable/table-header.vue
// module id = 270
// module chunks = 1